export const isScrolledToBottom = (element: Element, threshold: number = 2) =>
  Math.abs(element.scrollHeight - element.clientHeight - element.scrollTop) <=
  threshold;

export const isVerticallyScrollable = (element: Element) =>
  element.scrollHeight > element.clientHeight;

export const sortElementsByDocumentPosition = (elements: Element[]) =>
  elements.sort((firstElement, secondElement) =>
    firstElement.compareDocumentPosition(secondElement) &
    Node.DOCUMENT_POSITION_FOLLOWING
      ? -1
      : 1,
  );

export const scrollToTop = () => window.scrollTo(0, 0);
